import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmExperimentsContext: MembershipAwarenessFormFcmExperimentsContext,
	FcmExperimentsProvider: MembershipAwarenessFormFcmExperimentsContextProvider,
	useFcmExperiments: useMembershipAwarenessFormFcmExperiments,
	useAsyncFcmExperiments: useAsyncMembershipAwarenessFormFcmExperiments,
	prefetchFcmExperiments: prefetchMembershipAwarenessFormFcmExperiments,
} = createFcmExperimentsContext({
	name: 'MembershipAwarenessFormFcmExperimentsContext',
	dataProperty: 'formFcmExperiments',
	configs: {},
	prefetch: true,
});

export type MembershipAwarenessFormFcmExperimentsState = ReturnType<
	typeof useAsyncMembershipAwarenessFormFcmExperiments
>;
export type MembershipAwarenessFormFcmExperiments = LoadedStateData<MembershipAwarenessFormFcmExperimentsState>;
